var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17 15.368 2 5.739a27.881 27.881 0 0 1-14 0l2-5.739m10 0H7m10 0v-1.003c0-.755-.672-1.367-1.5-1.367s-1.5-.611-1.5-1.366v-.455h-.597M7 15.367v-1.003c0-.755.672-1.367 1.5-1.367s1.5-.611 1.5-1.366v-.455h.762M8.5 18.83l-.51 2.88M12 17.894V22m3.5-3.17.561 2.874m-2.658-10.526.058-7.875c0-1.736-2.64-1.736-2.64 0l-.06 7.875m2.642 0h-2.641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.c88b09da6506b4c5ecc2e8951d7792af.svg";
export { ForwardRef as ReactComponent };